module.exports = __webpack_public_path__ + "static/media/1 35 hvis.35121a8b.mp3";